import React, { useEffect, useState } from "react";
import { PRICE, WHOP_URL } from "../data/content";

export default function StickyBar() {
    const [show, setShow] = useState(false);
    useEffect(() => {
        const onScroll = () => setShow(window.scrollY > 800);
        window.addEventListener("scroll", onScroll, { passive: true });
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    return (
        <div
            data-testid="sticky-bar"
            className={`fixed bottom-0 left-0 right-0 z-40 transition-transform duration-500 ${
                show ? "translate-y-0" : "translate-y-full"
            }`}
        >
            <div className="bg-[#070303]/95 backdrop-blur-md border-t border-[#7A0000]/30">
                <div className="max-w-7xl mx-auto px-6 sm:px-10 py-4 flex items-center justify-between gap-4">
                    <div className="flex items-center gap-4 min-w-0">
                        <span className="inline-block w-1.5 h-1.5 bg-[#7A0000] ember flex-shrink-0" />
                        <div className="min-w-0">
                            <div className="font-serif-display italic text-[#f4f4f0] text-base sm:text-lg leading-tight truncate">
                                The Varek Code — Launch Window
                            </div>
                            <div className="text-[10px] tracking-[0.24em] uppercase text-neutral-500 mt-0.5">
                                <span className="line-through mr-2">
                                    {PRICE.original}
                                </span>
                                {PRICE.discounted} · {PRICE.discountLabel}
                            </div>
                        </div>
                    </div>
                    <a
                        href={WHOP_URL}
                        target="_blank"
                        rel="noopener noreferrer"
                        data-testid="sticky-cta"
                        className="btn-primary !py-3 !px-5 flex-shrink-0 text-[10px]"
                    >
                        <span className="hidden sm:inline">
                            Acquire the Code
                        </span>
                        <span className="sm:hidden">Acquire</span>
                        <span aria-hidden>→</span>
                    </a>
                </div>
            </div>
        </div>
    );
}
